<template>
  <div>
    <v-tabs v-model="activeTab" show-arrows height="36">
      <v-tab v-for="cat in categories" :key="cat.key" class="text-none">
        {{ $t(cat.labelKey) }}
      </v-tab>
    </v-tabs>

    <div class="symbol-grid pt-3">
      <div
        v-for="symbol in currentSymbols"
        :key="symbol.key"
        class="symbol-tile"
        :class="{ selected: isSelected(symbol.key) }"
        @click="toggle(symbol.key)"
      >
        <div class="symbol-art">
          <img
            v-if="!failed[symbol.key]"
            :src="symbol.file"
            :alt="$t(symbol.labelKey)"
            @error="failed = { ...failed, [symbol.key]: true }"
          />
          <!-- Placeholder shown until the official SVG is added -->
          <div
            v-else
            class="symbol-fallback"
            :style="{ borderColor: categoryColorFor(symbol.category) }"
          >
            {{ $t(symbol.labelKey) }}
          </div>
        </div>
        <div class="symbol-label">{{ $t(symbol.labelKey) }}</div>
        <v-icon v-if="isSelected(symbol.key)" small color="primary" class="check">
          mdi-check-circle
        </v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SYMBOL_CATEGORIES,
  symbolsByCategory,
  categoryColor,
} from "../../data/safetySymbols";

export default {
  name: "safetySymbolPicker",
  props: {
    // v-model: array of selected symbol keys
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      activeTab: 0,
      categories: SYMBOL_CATEGORIES,
      failed: {},
    };
  },
  computed: {
    currentSymbols() {
      const cat = this.categories[this.activeTab];
      return cat ? symbolsByCategory(cat.key) : [];
    },
  },
  methods: {
    categoryColorFor(cat) {
      return categoryColor(cat);
    },
    isSelected(key) {
      return (this.value || []).includes(key);
    },
    toggle(key) {
      const next = this.isSelected(key)
        ? this.value.filter((k) => k !== key)
        : [...(this.value || []), key];
      this.$emit("input", next);
    },
  },
};
</script>

<style scoped>
.symbol-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
  gap: 10px;
}
.symbol-tile {
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  text-align: center;
  transition: border-color 0.15s, background 0.15s;
}
.symbol-tile:hover {
  border-color: var(--v-primary-base);
}
.symbol-tile.selected {
  border-color: var(--v-primary-base);
  background: rgba(0, 0, 0, 0.03);
}
.symbol-art {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.symbol-art img {
  max-height: 56px;
  max-width: 100%;
}
.symbol-fallback {
  width: 52px;
  height: 52px;
  border: 2px dashed;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.55rem;
  line-height: 1.1;
  padding: 2px;
  color: rgba(0, 0, 0, 0.6);
  overflow: hidden;
}
.symbol-label {
  margin-top: 4px;
  font-size: 0.72rem;
  line-height: 1.15;
}
.check {
  position: absolute;
  top: 4px;
  right: 4px;
}
</style>
